const previewMatchesListVideoSlider = (list: NodeListOf<HTMLElement>) => {
  const windowWidth = window.innerWidth;

  if (list.length) {
    list.forEach((item) => {
      const toggleButton = item.querySelector('.match-oveview-video-list__dropdown');
      const content = item.querySelector('.match-oveview-video-list__content');
      const wrapper = item.querySelector('.match-oveview-video-list__articles');

      toggleButton?.addEventListener('click', () => {
        content?.classList.toggle('match-oveview-video-list__content--open');
        toggleButton.classList.toggle('match-oveview-video-list__dropdown--open');
      });

      if (windowWidth > 680 && list.length && wrapper) {
        const slideButtons: HTMLButtonElement[] = Array.from(
          item.querySelectorAll('.match-oveview-video-list__btn-slider')
        );
        const items = item.querySelectorAll('.article-card');

        const itemsPerShift = 1;
        let currentShift = 0;

        slideButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const direction = button.dataset.id === 'prev-slide' ? -1 : 1;
            const wrapperShift = wrapper.getBoundingClientRect().left;

            currentShift = Math.max(
              0,
              Math.min(items.length - 1, currentShift + itemsPerShift * direction)
            );

            const currentScrollPosition =
              items[currentShift].getBoundingClientRect().left - wrapperShift;

            wrapper.scrollBy({ left: currentScrollPosition, behavior: 'smooth' });
          });
        });

        const handleSlideButtons = () => {
          slideButtons[0].style.display = currentShift === 0 || windowWidth < 680 ? 'none' : 'flex';
          slideButtons[1].style.display =
            currentShift >= items.length - 2 || windowWidth < 680 ? 'none' : 'flex';
        };

        wrapper.addEventListener('scroll', () => {
          handleSlideButtons();
        });
      }

      if (windowWidth < 680) {
        const slideButtons = item.querySelectorAll('.match-oveview-video-list__btn-slider');

        slideButtons.forEach((button) => {
          button.removeAttribute('style');
        });
      }
    });
  }
};

export { previewMatchesListVideoSlider };
